let refineButton = document.querySelector('#refine-products');
let filterPopUp = document.querySelector('.refine-wrapper');

if (refineButton) {
  refineButton.addEventListener('click', function() {
    filterPopUp.classList.toggle('open');
  });
}

jQuery(document).on('wpf_ajax_success', function() {
  filterPopUp = document.querySelector('.refine-wrapper');
  refineButton = document.querySelector('#refine-products');
  refineButton.addEventListener('click', function() {
    filterPopUp.classList.toggle('open');
  });
});
